export class Debouncer<V> {
	private callback!: (v: V) => any;

	private debounceTime = 0;

	private isDebouncing = false;

	private skipIfSame = false;

	private valueCache!: V;

	constructor({
		callback,
		debounceTime,
		skipIfSame,
	}: {
		callback: (v: V) => any;
		debounceTime: number;
		skipIfSame?: boolean;
	}) {
		this.callback = callback;
		this.debounceTime = debounceTime;
		this.skipIfSame = !!skipIfSame;
	}

	public debounce(value: V): void {
		if (this.valueCache === value && this.skipIfSame) {
			return;
		}

		this.valueCache = value;

		if (!this.isDebouncing) {
			this.isDebouncing = true;

			setTimeout(() => {
				this.callback(this.valueCache);
				this.isDebouncing = false;
			}, this.debounceTime);
		}
	}
}
